import {
    faFolderOpen, faClipboardCheck, faFileLines, faFileSignature, faMountain,
    faScaleBalanced, faGavel, faBook,
    faFilePdf, faFileWord, faFileExcel, faFilePowerpoint, faFileImage, faFileZipper,
    faDraftingCompass, faFile,
} from '@fortawesome/free-solid-svg-icons';

// Valor de "icone" em documentos/_catalogo.json -> ícone da pasta
const PASTAS = {
    pasta: faFolderOpen,
    checklist: faClipboardCheck,
    formulario: faFileLines,
    termo: faFileSignature,
    terraplanagem: faMountain,
    legislacao: faScaleBalanced,
    resolucao: faGavel,
    norma: faBook,
};

export const iconePasta = (nome) => PASTAS[nome] || faFolderOpen;

// Ícone e cor por tipo de arquivo (classe "tipo--*" em documentos.scss)
const TIPOS = {
    PDF: { icone: faFilePdf, cor: 'pdf' },
    Word: { icone: faFileWord, cor: 'word' },
    Excel: { icone: faFileExcel, cor: 'excel' },
    Planilha: { icone: faFileExcel, cor: 'excel' },
    PowerPoint: { icone: faFilePowerpoint, cor: 'ppt' },
    Imagem: { icone: faFileImage, cor: 'img' },
    ZIP: { icone: faFileZipper, cor: 'zip' },
    RAR: { icone: faFileZipper, cor: 'zip' },
    AutoCAD: { icone: faDraftingCompass, cor: 'cad' },
    Revit: { icone: faDraftingCompass, cor: 'cad' },
};

export const iconeTipo = (tipo) => TIPOS[tipo] || { icone: faFile, cor: 'outro' };
